import { z } from 'zod'

export const PaginationSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
})

export const UuidSchema = z.string().uuid()

/** DB からは Date、JSON 経由では ISO 文字列で届く日時 */
export const DateOrStringSchema = z.union([z.date(), z.string()])

export type PaginationInput = z.infer<typeof PaginationSchema>
